<!-- <template>
    <div class="password-reset-confirm">
      <h2>Ingresa tu nueva contraseña</h2>
      <form @submit.prevent="submitNewPassword">
        <input
          type="password"
          v-model="password"
          placeholder="Nueva contraseña"
          required
        />
        <button type="submit">Cambiar contraseña</button>
        <p v-if="message" class="success">{{ message }}</p>
        <p v-if="error" class="error">{{ error }}</p>
      </form>
    </div>
  </template> -->
<template>
  <v-app>
    <v-main>
      <!-- Fondo atractivo con gradiente -->
      <div class="register-background d-flex align-center justify-center">
        <v-col cols="12" sm="8" md="5">
          <!-- Card de registro con sombras y bordes -->
          <v-card class="elevation-12 rounded-lg" max-width="650">
            <v-toolbar dark color="primary">
              <v-toolbar-title align="center"
                >Ingresa tu nueva contraseña</v-toolbar-title
              >
            </v-toolbar>

            <v-card-text>
              <form ref="form" @submit.prevent="submitNewPassword">
                <v-row>
                  <v-col cols="12" sm="12">
                    <!-- Campo para contraseña nueva-->
                    <v-text-field
                      v-model="password"
                      name="password"
                      label="Nueva Contraseña"
                      type="password"
                      placeholder="Ingresa tu Nueva Contraseña"
                      required
                      outlined
                      dense
                      :rules="[validateFields]"
                      class="mb-2"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>

                <!-- Divider para separar secciones -->
                <v-divider class="my-4"></v-divider>

                <!-- Botón de registro -->
                <v-btn
                  type="submit"
                  class="mx-auto d-block mt-4 mb-4"
                  color="primary"
                  elevation="5"
                  :ripple="true"
                  :disabled="!isPasswordValid"
                >
                  Cambiar Contraseña
                </v-btn>
              </form>
              <p>
                <strong
                  >** Nota: La contraseña debe cumplir con lo siguiente.</strong
                >
              </p>
              <!-- Validaciones visuales de la contraseña -->
              <v-list dense class="mb-4 pa-0">
                <v-list-item
                  class="pa-0"
                  v-for="(rule, index) in passwordRules"
                  :key="index"
                >
                  <v-icon color="success" v-if="rule.valid"
                    >mdi-check-circle</v-icon
                  >
                  <v-icon color="error" v-else>mdi-close-circle</v-icon>
                  <span class="ml-2">{{ rule.message }}</span>
                </v-list-item>
              </v-list>

              <!-- Enlace para redirigir a login -->
              <p class="text-center">
                <router-link to="/index" class="font-weight-bold text-primary"
                  >Inicia sesión aquí</router-link
                >
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </div>
      <v-snackbar
        v-model="showSnackbar"
        :color="snackbarColor"
        timeout="4000"
        location="top right"
        position="fixed"
      >
        <v-icon left class="mr-2">{{ icon }}</v-icon>
        {{ snackbarMessage }}
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import api from "@/api/axios/axios.js";

export default {
  name: "PassConfirm",
  data() {
    return {
      password: "",
      message: "",
      error: "",
      showSnackbar: false,
      snackbarColor: "success",
      icon: null,
      snackbarMessage: "",
    };
  },
  mounted() {
    this.uidb64 = this.$route.params.uidb64;
    this.token = this.$route.params.token;
  },
  computed: {
    isPasswordValid() {
      return this.passwordRules.every((rule) => rule.valid);
    },
    passwordRules() {
      return [
        {
          message: "Debe tener al menos 8 caracteres",
          valid: this.password.length >= 8,
        },
        {
          message: "Debe contener al menos una mayúscula",
          valid: /[A-Z]/.test(this.password),
        },
        {
          message: "Debe contener al menos un número",
          valid: /\d/.test(this.password),
        },
        {
          message: "Debe contener un carácter especial",
          valid: /[!@#$%^&*(),.?":{}|<>]/.test(this.password),
        },
      ];
    },
  },
  methods: {
    async submitNewPassword() {
      try {
        const response = await api.post(
          `/login/reset/confirm/${this.uidb64}/${this.token}/`,
          { password: this.password },
        );
        //   this.message = response.data.message
        this.error = "";
        this.snackbarMessage = response.data.message;
        //console.log(this.snackbarMessage)
        this.icon = "mdi-check-circle-outline";
        this.showSnackbar = true;
        this.password = "";
      } catch (err) {
        //console.log(err)
        this.snackbarMessage =
          err.response?.data?.error || "Error al restablecer la contraseña";
        this.snackbarColor = "error";
        this.icon = "mdi-alert-circle";
        this.showSnackbar = true;
        this.password = "";
      }
    },
  },
};
</script>
